import React, {Component} from 'react';
import {browserHistory} from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {registerUser} from '../../actions/firebase_actions';

class UserRegister extends Component {
    constructor(props) {
        super(props);
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.translateMessage = this.translateMessage.bind(this);
        this.state = {
            message: '',
        };
    }

    translateMessage(message) {
        console.log(message);
        switch (message) {
            case 'The email address is already in use by another account.':
                return 'Email je už zaregistrovaný';
            case 'Password should be at least 6 characters':
                return 'Heslo by malo obsahovať aspoň 6 znakov';
            case 'The email address is badly formatted.':
                return 'Zadaj správny email';
            case 'The password must be 6 characters long or more.':
                return "Heslo musí obsahovať aspoň 6 znakov.";
            default:
                return message;
        }
    }

    onFormSubmit(event) {
        event.preventDefault();

        const email = this.refs.email.value;
        const password = this.refs.password.value;
        this.props.registerUser({email, password}).then((data) => {
                if (data.payload.errorCode) {
                    this.setState({message: this.translateMessage(data.payload.errorMessage)})
                    ;
                } else {
                    browserHistory.push('/driver-profile');
                }
            }
        );
    }

    render() {
        return (
            <div className="col-md-6">
                <div className="panel panel-default">
                    <img style={{width: "100%"}} src="https://firebasestorage.googleapis.com/v0/b/drivers-app-8541f.appspot.com/o/public%2Fdriver.png?alt=media&token=6726de20-921a-484b-916b-277a594eb26b" />
                    <div className="panel-body">

                        <div className="alert alert-info">
                            <ol>
                                <li>Zaregistruj sa</li>
                                <li>Vyplň formulár</li>
                                <li>Ozveme sa Ti ešte dnes!</li>
                            </ol>
                        </div>

                        <form id="frmRegister" role="form" onSubmit={this.onFormSubmit}>
                            {(this.state.message) && (
                                <div className="alert alert-danger">{this.state.message}</div>
                            )}
                            <h2>Registrácia</h2>
                            <div className="form-group">
                                <label htmlFor="txtRegEmail">Emailová adresa</label>
                                <input
                                    type="email" className="form-control" ref="email" id="txtEmail"
                                    placeholder="Zadaj email"
                                    name="email"
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="txtRegPass">Heslo</label>
                                <input
                                    type="password" className="form-control" ref="password" id="txtPass"
                                    placeholder="Heslo"
                                    name="password"
                                />
                            </div>
                            <button type="submit" className="btn btn-default btn-block">Registrovať</button>
                            <br /> <br />

                        </form>
                    </div>
                </div>
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        registerUser,
    }, dispatch);
}

function mapStateToProps(state) {
    return {currentUser: state.currentUser};
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegister);



// WEBPACK FOOTER //
// ./src/app/components/user/register.jsx